import styled from "styled-components";
import { media } from "../../../style/media";

const Container = styled.div`
  width: 100%;
  height: 100%;
  /* ${({ theme }) => (theme ? "background: " + theme : "")}; */

  ${media.m`
    min-width: 900px;
  `}

  ${media.s`
    min-width: 700px;
  `}
`;

export default Container;
